export default function ZHBEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/zhb/Zoning-Map.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Zoning Map
          </a>
        </td>
        <td>09/17/2024</td>
        {/*End File*/}
      </tr>
    </table>
  );
}
